import React from 'react';
import FormFieldHeader from './FormFieldHeader.js';

const FormSection = (props) => (
  	<div className="FormSection">
		{props.header ?
		<FormFieldHeader
			header={props.header}
			help={props.help} /> : null}
		{props.children}
	</div>
)

export default FormSection


// WEBPACK FOOTER //
// ./src/components/form/FormSection.js